<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-2">{{ getTitle }}</h1>
    <v-row class="mb-0 pb-0">
      <!-- form  -->
      <v-col cols="12" md="12">
        <journal-reveived-data-form @number="setNumber" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import JournalReveivedDataForm from './components/JournalReveivedDataForm'
export default {
  name: 'AdminJournalReceivedForm',
  components: {
    JournalReveivedDataForm,
  },
  mixins: [userRole],
  data() {
    return {
      number: '',
      type: null,
      pageloading: false,
    }
  },
  computed: {
    getTitle() {
      return `${this.$t('Dokumentas')}: ${this.getDocumentNo}`
    },
    getDocumentNo() {
      return this.number
    },
    showEditForm() {
      return this.type === 'edit'
    },
    showViewForm() {
      return this.type === 'view'
    },
    viewType() {
      return this.$route.name === 'adminJournalReceivedFormView'
    },
  },
  beforeDestroy() {},
  created() {
    this.type = this.viewType ? 'view' : 'edit'
  },
  methods: {
    setNumber(number){
      this.number = number
    },
  },
}
</script>
<style lang="scss" scoped></style>
